// Admin Configuration
// In production, these should be environment variables
export const ADMIN_CONFIG = {
  username: process.env.VUE_APP_ADMIN_USERNAME || 'admin',
  password: process.env.VUE_APP_ADMIN_PASSWORD || 'multicare2025',
  sessionDuration: process.env.VUE_APP_ADMIN_SESSION_DURATION || 86400000, // 24 hours
  maxLoginAttempts: 5,
  lockoutDuration: 300000, // 5 minutes
}

// Security settings
export const SECURITY_CONFIG = {
  requireHttps: process.env.NODE_ENV === 'production',
  allowedIPs: process.env.VUE_APP_ALLOWED_IPS ? process.env.VUE_APP_ALLOWED_IPS.split(',') : [],
  enableRateLimit: true,
  enableAuditLog: true
} 